import React, { useState, useEffect } from "react";
import { addContact } from "../Adapter/HomePageAdapter";
import { fetchContactPageSeo } from "../Adapter/PageAdapter";
import { Toaster, toast } from 'sonner';
import { Checkbox, FormControlLabel } from '@mui/material';
// import useSeo from "../hooks/useSeo";
// import SeoHelmet from "../components/SeoHelmet";
import { Helmet } from "react-helmet-async";
import { baseImage_path } from "../variables/Variables";
import { stripHtmlForMeta } from "../utils/seoMetaText";
import ContactBan from "../assets/images/Contact us.jpg";
import ContaIc1 from "../assets/images/conmapicn.svg";
import ContaIc2 from "../assets/images/coninfoicn.svg";
import ContaIc3 from "../assets/images/concallicn.svg";
import AccessIcn from "../assets/images/aceess-con-icn.svg";
import RoadIcn from "../assets/images/road-conicn.svg";
import RailIcn from "../assets/images/train-conicn.svg";
import AirIcn from "../assets/images/air-conicn.svg";
import WhiteArr from "../assets/images/arrw.svg";

const ContactUs = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
    file: null,
    agree: false
  });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [seoData, setSeoData] = useState(null);

  useEffect(() => {
    const loadSeo = async () => {
      try {
        console.log("Calling fetchContactPageSeo...");
        const res = await fetchContactPageSeo();
        console.log("API Response:", res);
        if (res && res.data) {
          setSeoData(res.data);
        }
      } catch (e) {
        console.error("Direct SEO fetch failed:", e);
      }
    };

    loadSeo();
  }, []);

  // const seoData = useSeo(fetchContactPageSeo);

  const validateForm = () => {
    const newErrors = {};

    if (!formData.name.trim()) {
      newErrors.name = "Name is required.";
    }

    if (formData.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      newErrors.email = "Invalid email address.";
    }

    if (!formData.phone.trim()) {
      newErrors.phone = "Phone number is required.";
    } else if (!/^[0-9]{10}$/.test(formData.phone)) {
      newErrors.phone = "Invalid phone number. Must be 10 digits.";
    }


    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value, type, checked, files } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : type === 'file' ? files[0] : value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (loading) return;

    if (!validateForm()) {
      toast.error("Please fill all required fields.");
      return;
    }

    setLoading(true);

    try {
      const payload = {
        name: formData.name,
        email: formData.email,
        phone: formData.phone,
        message: formData.message,
        agree: formData.agree ? "true" : "false"
      };

      // Call both APIs
      const response = await addContact(payload);

      if (response.existingApiResponse?.message && !response.crmResponse?.error) {
        toast.success("Form submitted successfully, We will get back to you soon!");
        setFormData({ name: "", email: "", phone: "", message: "", agree: false });
      } else {
        toast.error("Submission failed. Please try again.");
      }
    } catch (error) {
      toast.error("An error occurred. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {/* {seoData && <SeoHelmet seoData={seoData} />} */}
      {seoData && (
        <Helmet>
          <title>{seoData.seo_title}</title>
          <meta name="title" content={seoData.meta_title} />
          <meta name="description" content={stripHtmlForMeta(seoData.meta_description)} />
          <meta name="keywords" content={seoData.meta_keywords} />

          <meta property="og:title" content={seoData.og_title} />
          <meta property="og:description" content={stripHtmlForMeta(seoData.og_description)} />
          <meta property="og:type" content={seoData.og_type} />
          <meta property="og:url" content={seoData.og_url} />
          <meta property="og:image" content={`${baseImage_path}/${seoData.og_image}`} />
          <meta property="og:locale" content={seoData.og_locale} />
          <meta property="og:site_name" content={seoData.og_site_name} />
          <meta property="article:modified_time" content={seoData.article_modified_time} />

          <meta name="twitter:card" content={seoData.twitter_card} />
          <meta name="twitter:title" content={seoData.twitter_title} />
          <meta name="twitter:description" content={stripHtmlForMeta(seoData.twitter_description)} />
          <meta name="twitter:image" content={`${baseImage_path}/${seoData.twitter_image}`} />
          <meta name="twitter:site" content={seoData.twitter_site} />

          <link rel="canonical" href={seoData.canonical_link} />

          {/* Custom scripts injection */}
          {seoData.custom_scripts && (
            <script type="text/javascript" dangerouslySetInnerHTML={{ __html: seoData.custom_scripts }} />
          )}
        </Helmet>
      )}

      {/* Banner Section */}
      <section className="banner-spac">
        <div className="cust-container">
          <div className="banner-box">
            <img src={ContactBan} alt="Contact Us Banner" />
            <div className="ban-con">
              <h1>Contact Us</h1>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Information & Form */}
      <section className="contact-form-sec">
        <div className="cust-container">
          <div className="row">
            {/* Contact Details */}
            <div className="col-xl-7 col-lg-7 col-md-12 col-sm-12 mb-4">
              <div className="left-touch">
                <div className="contact-form-add-item">
                  <div className="contact-form-add-item-img">
                    <img src={ContaIc1} alt="Location Icon" />
                  </div>
                  <p>
                    <a
                      href="https://maps.app.goo.gl/Mz19gFVtx2GTtj6T8"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      S.L. Raheja Hospital - A Fortis Associate,<br />
                      Diabetic Association Of India,<br />
                      Raheja Rugnalaya Marg,<br />
                      Mahim West, Mumbai,<br />
                      Maharashtra, India - 400016.
                    </a>
                  </p>
                </div>
                <div className="contact-form-add-item">
                  <div className="contact-form-add-item-img">
                    <img src={ContaIc2} alt="Email Icon" />
                  </div>
                  <p>
                    <a href="mailto:info@rahejahospital.com">info@rahejahospital.com</a>
                  </p>
                </div>
                <div className="contact-form-add-item">
                  <div className="contact-form-add-item-img">
                    <img src={ContaIc3} alt="Phone Icon" />
                  </div>
                  <div className="contact-form-add-item-desc">
                    <p>
                      Boardline No: <a href="tel:022-69871211">022-69871211</a> /{" "}
                      <a href="tel:+919167676790">9167676790</a>
                      <br />
                      <span>Emergency No: </span>
                      <a href="tel:022-66529979">022-66529979</a>
                    </p>
                  </div>
                </div>
              </div>

              {/* Accessibility Information */}
              <div className="hosp-acceessible-head">
                <div className="access-head-img">
                  <img src={AccessIcn} alt="Accessibility Icon" />
                </div>
                <div className="access-head-desc">
                  <p>S.L. Raheja Hospital is conveniently located and easily accessible:</p>
                </div>
              </div>

              <div className="access-row">
                <div className="acees-row-item">
                  <div className="card-end text-center cardend-border">
                    <div className="cardi-img">
                      <img src={RoadIcn} alt="By Road Icon" />
                    </div>
                    <h3>By Road</h3>
                    <p>Well-connected via major roads and highways.</p>
                  </div>
                </div>
                <div className="acees-row-item">
                  <div className="card-end text-center cardend-border">
                    <div className="cardi-img">
                      <img src={RailIcn} alt="By Rail Icon" />
                    </div>
                    <h3>By Rail</h3>
                    <p>10-minute walk (1.0 Km) & 3-min taxi ride from Mahim Railway Station.</p>
                  </div>
                </div>
                <div className="acees-row-item">
                  <div className="card-end text-center cardend-border">
                    <div className="cardi-img">
                      <img src={AirIcn} alt="By Air Icon" />
                    </div>
                    <h3>By Air</h3>
                    <p>12 km from Chhatrapati Shivaji Maharaj International Airport.</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Contact Form */}
            <div className="col-xl-5 col-lg-5 col-md-12 col-sm-12 mb-4">
              <div className="right-touch">
                <h3>Get In Touch</h3>
                <p>
                  * Your contact information will remain strictly confidential and will not be published or shared. Required fields are marked.
                </p>

                <form onSubmit={handleSubmit} className="cot-frm">
                  <div className="form-holder">
                    <label htmlFor="name">Full Name*</label>
                    <input type="text" id="name"
                      name="name" placeholder="Please enter full name"
                      value={formData.name} onChange={handleChange} />
                    {errors.name && <small className="error">{errors.name}</small>}
                  </div>

                  <div className="form-holder">
                    <label for="phone">Phone Number*</label>
                    <div className="form-holder-row">
                      <input type="number" id="phone"
                        name="phone" placeholder="Please enter phone number"
                        value={formData.phone} onChange={handleChange} /><br />
                      {errors.phone && <small className="error">{errors.phone}</small>}
                    </div>
                  </div>

                  <div className="form-holder">
                    <label htmlFor="email">Email</label>
                    <input type="email" id="email"
                      name="email" placeholder="Please enter your email"
                      value={formData.email} onChange={handleChange} />
                    {errors.email && <small className="error">{errors.email}</small>}
                  </div>

                  <div className="form-holder">
                    <label htmlFor="message">Your Message</label>
                    <textarea id="message"
                      name="message" placeholder="Please write your message here" rows="5"
                      value={formData.message} onChange={handleChange}></textarea>
                    {errors.message && <small className="error">{errors.message}</small>}
                  </div>

                  <div className="check-box">
                    <div className="tnc-accpt">
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={formData.agree}
                            onChange={handleChange}
                            name="agree"
                            color="primary"
                          />
                        }
                        label="I agree to the terms and conditions"
                      />
                    </div>
                    <div className="upload-file">
                      <label for="">Upload Reports (Optional)</label>
                      <input type="file" name="file" />
                    </div>
                  </div>

                  <button type="submit" className="btn with-color with-arr" disabled={loading}>
                    {loading ? "Sending..." : <>
                      <img src={WhiteArr} alt="" /> Send Message Now
                    </>}
                  </button>
                  <Toaster position="top-right" />
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Embedded Google Map Section */}
      <section className="cont-map-sec margnbot50">
        <div className="mapouter">
          <iframe
            title="Google Map"
            className="gmap_iframe"
            width="100%"
            height="400"
            frameBorder="0"
            scrolling="no"
            src="https://maps.google.com/maps?q=fortis%20SL%20raheja%20hospital&t=&z=17&ie=UTF8&iwloc=B&output=embed"
          ></iframe>
        </div>
      </section>
    </>
  );
};

export default ContactUs;
